import { FilterType } from '@/enums'

export const normalizeFilterRules: { [name: string]: any } = {
  status: { type: FilterType.Input },
  raw: { type: FilterType.Boolean },
}
